import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FooterTransition"] */ "/home/runner/work/web/web/src/components/Backgrounds/FooterTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalBackground"] */ "/home/runner/work/web/web/src/components/Backgrounds/GlobalBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/Layout/Header.tsx");
